/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/interactive-supports-focus */
import React, { useContext } from 'react'; //eslint-disable-line
import { useHistory } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import format from 'date-fns/format';

// import logo from '../styles/img/footer_design_cropped.png';
import GoLogo from '../components/GoLogo';
import * as CONSTS from '../utils/constants';
import goTrackerConfig from 'goTrackerConfig';
import viewStoreContext from '../stores/viewStore';

const HeaderContainer = observer(() => {
  const viewStore = useContext(viewStoreContext);
  const history = useHistory();

  const handleMenu = () => {
    viewStore.toggleMenu();
  };

  const handleHome = () => {
    history.push(CONSTS.VIEW_PATHS.HOME, { isLoaded: true });
  };

  return (
    <header className="header-container">
      {goTrackerConfig.debug && <div className="debug-container refresh">GO Tracker 3 v{goTrackerConfig.version || '1.0.0'} Refreshed Time: {format(viewStore.autoRefreshTime, 'HH:mm:ss')}</div>}
      <div className="logo-container" role="button" title="go to home page" onClick={handleHome}>
        {/* <img className="go-logo" src={logo} alt="goTracker" /> */}
        <GoLogo />
      </div>
      <nav className="header-nav-container">
        <button className="nav-buttons" aria-label="menu" onClick={handleMenu}>
          <i className="fa fa-bars x-large" />
        </button>
      </nav>
      <div className="header">
        <span className="title">GO Tracker</span>
      </div>
    </header>
  );
});

export default HeaderContainer;
